export let locked = false; // eslint-disable-line import/no-mutable-exports

export const lockScroll = (() => {
  let position = 0;
  /**
   * Locks or unlocks the scroll
   * @param {boolean} lock
   */
  return (lock) => {
    if (lock === locked) return;
    if (lock) {
      position = window.scrollY;
      document.body.style.top = `${-position}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('overflow');
      window.scrollTo(0, position);

      position = 0;
    }
    locked = lock;
  };
})();

export default {
  lockScroll,
};
